import { useEffect, useRef, useState } from 'react';

export const useLazyVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    const videoElement = videoRef.current;
    const containerElement = containerRef.current;
    if (!videoElement || !containerElement) return;

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      const [entry] = entries;
      if (entry.isIntersecting && !isVideoLoaded) {
        const sourceTags = videoElement.querySelectorAll('source');
        sourceTags.forEach((source: HTMLSourceElement) => {
          if (source.dataset.src) {
            source.src = source.dataset.src;
          }
        });

        if (videoElement.dataset.src) {
          videoElement.src = videoElement.dataset.src;
        }

        videoElement.load();

        if (videoElement.hasAttribute('autoplay')) {
          void videoElement.play();
        }

        setIsVideoLoaded(true);
        observer.unobserve(containerElement);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: document,
      rootMargin: '1000px 1500px',
      threshold: 0,
    });

    observer.observe(containerElement);

    return () => {
      if (containerElement) {
        observer.unobserve(containerElement);
      }
    };
  }, [isVideoLoaded]);

  return { videoRef, containerRef, isVideoLoaded };
};
